import { render } from "./DatabasesView.vue?vue&type=template&id=41b2eecf&ts=true"
import script from "./DatabasesView.vue?vue&type=script&lang=ts"
export * from "./DatabasesView.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__